import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.planning')
  .factory('$planningTemplatesDefaultDraft', planningTemplatesDefaultDraft);

function planningTemplatesDefaultDraft($bringozFactory: $bringozFactory,
                                       PlanningTemplatesDefaultDraftAPI: BringozApi,
                                       Planning_Templates_Default_Draft: DataStoreConfig) {

  function $planningTemplatesDefaultDraft(id: string) {
    return $bringozFactory(id, PlanningTemplatesDefaultDraftAPI, Planning_Templates_Default_Draft)
  }

  return $planningTemplatesDefaultDraft
}
